import { createContext, useContext } from 'react';

export interface BillingModalContextValue {
  openPlanModal: () => void;
}

export const BillingModalContext = createContext<BillingModalContextValue | undefined>(undefined);

export function useBillingModal() {
  const context = useContext(BillingModalContext);

  if (!context) {
    throw new Error('useBillingModal must be used within a BillingModalProvider');
  }

  return context;
}
